import { useIntl } from 'react-intl';
import { createNumberCell } from 'components/table/DataTableUtil';

export function NumberCell({
  value,
  minFraction = 0,
  maxFraction = 0,
  className = '',
}: {
  value: number;
  minFraction?: number;
  maxFraction?: number;
  className?: string;
}) {
  const intl = useIntl();
  return createNumberCell(
    intl.formatNumber(value, { minimumFractionDigits: minFraction, maximumFractionDigits: maxFraction }),
    className
  );
}
